import { render, staticRenderFns } from "./VideoOverlaySection.vue?vue&type=template&id=587e5e7f&scoped=true"
import script from "./VideoOverlaySection.vue?vue&type=script&lang=ts"
export * from "./VideoOverlaySection.vue?vue&type=script&lang=ts"
import style0 from "./VideoOverlaySection.vue?vue&type=style&index=0&id=587e5e7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587e5e7f",
  null
  
)

export default component.exports